export const PCMP_PROJECT_LIST_PAGE_SIZE = 20;

export const PCMP_PROJECT_ACTIVE_FILTER = ['active', 'inactive'] as const;
export type PcmpProjectActiveFilter = (typeof PCMP_PROJECT_ACTIVE_FILTER)[number];

export const PcmpProjectActiveFilterLabels = {
  active: 'Active',
  inactive: 'Inactive',
} as const satisfies Record<PcmpProjectActiveFilter, string>;

// Limits from the API (legacy ValidateModel).
export const PCMP_PROJECT_NAME_MAX_LENGTH = 200;
export const PCMP_PROJECT_CODE_MAX_LENGTH = 50;
export const PCMP_PROJECT_DESCRIPTION_MAX_LENGTH = 1000;
export const PCMP_PROJECT_SL_NO_MAX = 32767;
export const PCMP_CATEGORY_NAME_MAX_LENGTH = 200;
export const PCMP_BOOK_PRICE_MAX = 9_999_999.99;
